import { render, staticRenderFns } from "./AttendanceSetting.vue?vue&type=template&id=1cff3a84&scoped=true&"
import script from "./AttendanceSetting.vue?vue&type=script&lang=js&"
export * from "./AttendanceSetting.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceSetting.vue?vue&type=style&index=0&id=1cff3a84&lang=scss&scoped=true&"
import style1 from "./AttendanceSetting.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cff3a84",
  null
  
)

export default component.exports